import WheresYourCarForm from "./Form";
import { useWheresYourCar } from "./hooks/useWheresYourCar";

export const WheresYourCar = () => {
  const props = useWheresYourCar();
  return <WheresYourCarForm {...props} />;
};

export default WheresYourCar;
